<template>
  <div>
  <modal :item="about" v-show="show" v-on:hide="show = false"></modal>
  <transition name="fade">
    <nav class="site-navigation" v-show="visible">
      <ul>
        <li>
          <div @click="scrollToTop">
            <div class="link"><i class="icon icon--arrow-top"></i>
              <div><span>Nach</span> oben</div>
            </div>
          </div>
        </li>
        <li @click="showModal(index)">
          <div class="link">
            <i class="icon icon--circle"></i>
            <div><span>Über</span> mich</div>
          </div>
        </li>
        <li>
          <jump target=".instagram">
            <div class="link">
              <i class="icon icon--hash"></i>
              <div><span>Dein</span> <span>Lieb</span> ding</div>
            </div>
          </jump>
        </li>
      </ul>
    </nav>
  </transition>
  </div>
</template>

<script>
import EventBus from '@/event-bus.js'
import Modal from '@/components/Modal'
import Jump from '@/components/Jump'
import jump from 'jump.js'
import { getScroll } from '@/util'

export default {
  props: {
    visibilityHeight: {
      type: Number,
      default: 400
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    'jump': Jump,
    'modal': Modal
  },
  data () {
    return {
      visible: false,
      show: false,
      about: {
        name: 'Michael Wallner',
        description: 'MedienDesigner  |  1987 geboren | <a href="http://michi-wallner.de">http://michi-wallner.de</a>',
        image: 'portrait.jpg',
        story: 'Hallo, durch meine Dinge hast du bereits einiges über mich erfahren. Warum ich dieses Projekt mache? Ich möchte dazu anregen den Umgang mit Dingen und deren Wertschätzung zu reflektieren. Denn Dinge können bereichern, prägen, nerven und lassen uns erinnern wer wir sind. Ich freue mich jederzeit über Feedback zu liebdinge.com und über dein Lieblingsding auf Instagram unter #liebdinge.',
        hideNavigation: true
      }
    }
  },
  mounted () {
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll)
  },
  created () {
    EventBus.$on('showModal', (value) => {
      this.modal(!value)
    })
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      this.visible = getScroll(window, true) > this.visibilityHeight
    },
    scrollToTop () {
      jump(document.body, this.options)
    },
    showModal () {
      this.show = true
      this.$emit('active', this.index)
      EventBus.$emit('showModal', true)
      document.querySelector('body').style.overflow = 'hidden'
    },
    modal (value) {
      this.visible = value
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to {
  opacity: 0
}

.site-navigation {
  position: fixed;
  right: 80px;
  bottom: 80px;
  z-index: 999;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    line-height: 1.5;

    li {
      cursor: pointer;

      & + li {
        margin-top: 40px;
      }

      .link {
        display: flex;
        align-items: center;
        text-transform: uppercase;
        font-size: 13px;

        .icon {
          width: 37px;
          height: 37px;
        }
      }

      i {
        margin-right: 20px;
      }

      > div {
        letter-spacing: 6px;
      }

      i, span {
        display: block;
      }
    }

  }
}

.icon {
  display: inline-block;
  width: 50px;
  height: 50px;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;

  &--arrow-top {
    transform: rotate(90deg);
    background-image: url('/static/icon-arrow-left.svg');
  }

  &--circle {
    background-image: url('/static/icon-circle.svg');
  }
  &--hash {
    background-image: url('/static/icon-hash.svg');
  }
}
</style>



// WEBPACK FOOTER //
// Navigation.vue?7a9887d2